import store from '../store/store';
import types from '../store/types';

export class ItemHelper {

    public static drag = (e, index: number) => {
        store.dispatch({ type: types.SET_MOVE_FROM_CONTROL_ITEM, index: index });
    };

    public static drop = (e, toIndex: number) => {

        e.preventDefault();
        store.dispatch({ type: types.MOVE_CONTROL_ITEM, toIndex: toIndex });

    };

    public static allowDrop = (e, i: number) => {
        e.preventDefault();

        let overIndex = (store.getState() as any).modalState.overIndex;
        if (i !== overIndex)
            store.dispatch({ type: types.SET_MOVE_OVER_CONTROL_ITEM, index: i });
    };

}


// WEBPACK FOOTER //
// ./source/ts/helpers/items.ts